import React                   from 'react';
import { connect }             from 'react-redux';
import { reducerType }         from 'reducer';
import KeyRow                  from 'pages/tirgul/inputQuestion/KeyRow';
import keyBoardClick           from 'functions/keyBoard/keyBoardClick';
import handleSubmit            from 'functions/keyBoard/handleSubmit';
import compSize                from './inputCompSize';
import words                   from 'utils/words';
import BackspaceIcon           from '@mui/icons-material/Backspace';
import { makeStyles }          from "makeStyles";
import { componentsStateType } from 'reducer/types';
//import { componentsStateType } from 'reducer/types';

var clsx = require('classnames')

const { rootHeight, rootWidth, gap, submitHeight } = compSize;

const arr  = new Array(5).fill(0).map((val, ind) => { return `${ ind }` })
const arr2 = new Array(5).fill(0).map((val, ind) => { return `${ ind + 5 }` })

const boxShadow = '2px 3px 4px rgba(0,0,0,0.2)';

const useStyles = makeStyles()(
    (Theme) => ({
    root: {
      //  position:       'fixed',
        display:        'flex',
        flexFlow:       'column',
        transition:     'all 0.3s',
        width:          rootWidth,
        height:         rootHeight + submitHeight,
        transform:      `translate(${ -gap/2 }px, 0px)`,
    },
    container: {
        display: 'flex',
        width:   '100%',
        height:  rootHeight,
    },
    rowsContainer: {
        display:  'flex',
        flexFlow: 'column',
        flex:     '0.84',
        height:   '100%',
    },
    erase: {
        height:          rootHeight - gap,
        marginLeft:      gap,
        marginTop:       gap/2,
        flex:            '0.16',
        backgroundColor: Theme.red,
        borderRadius:    '0.5em',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        cursor:          'pointer',
        boxShadow:       boxShadow,
        '&:hover': {
            backgroundColor: Theme.darkRed,
        }
    },
    submit: {
        width:           rootWidth - gap,
        height:           submitHeight - gap,
        marginLeft:      gap,
        marginTop:       gap,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        borderRadius:    '0.5em',
        backgroundColor: Theme.green,
        color:           '#FFF',
        cursor:          'pointer',
        fontWeight:      'bold',
        boxShadow:       boxShadow,
        '&:hover': {
            backgroundColor: Theme.darkGreen,
        }
    },
    icon: {
       color: '#FFF'
    },
    feedBack: {
        position:       'absolute',
        left:           '50%',
        transform:      'translate(-50%, 0%)',
        top:            -50,
        height:         45,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        color:          Theme.darkBlue,
        fontSize:       Theme.normalFont
      },
    shake: {
        animation:               'shake 0.4s',
       // animationIterationCount: 'infinite',
    } 
}),
);

type InputQuestionProps = {
    question:        number;
    feedBack:        string;
    shake:           boolean;
    lastTest:        boolean;
    componentsState: componentsStateType;
    goToNextTest:    () => void;
}

const InputQuestion: React.FC<InputQuestionProps> = ({ 
    question,
    feedBack,
    shake,
    lastTest,
    componentsState,
    goToNextTest
 }) => {

 const { classes } = useStyles();


 const okButtonClick = () => {
   if ( componentsState.success || componentsState.failurCount >= 3 ) {
     goToNextTest();
   } 
   else {
     handleSubmit(question, 'input', lastTest)
   }
 }


  return (
      <div className = { shake ? clsx(classes.root, classes.shake) : classes.root }>
          <div className = { classes.container }>
                <div className = { classes.rowsContainer }>
                    <KeyRow 
                      question = { question }
                      arr      = { arr }
                    />
                    <KeyRow 
                      question = { question }
                      arr      = { arr2 }
                    />
                </div>
                <div  
                    className = { classes.erase }
                    onClick   = { () => keyBoardClick('-1') }
                >
                     <BackspaceIcon className = { classes.icon } />
                </div>
         </div>
         <div 
           className = { classes.submit }
           onClick   = { okButtonClick }
         >
           { (componentsState.success || componentsState.failurCount >= 3) ? words['continue'] : words['submit'] }
        </div> 
     <div 
        dir       = 'rtl'
        className = { classes.feedBack }
     >
           { !!feedBack.length ? feedBack : "" }
        </div>
    </div>
  );
}





const mapStateToProps = (reducer: reducerType) => {
    return {
      componentsState: reducer.components,
  }};
    
  export default connect(mapStateToProps)(InputQuestion);
    
    
    
    